/*
 * function clickAsLink(url, event)
 *
 * Allows treating a click event as if a hyperlink was clicked.
 * Opens a new tab or window if a modifier key is pressed.
 */
export const clickAsLink = (window, url, event) => {
  if (event.shiftKey || event.ctrlKey || event.metaKey) {
    window.open(url);
  } else {
    window.location.assign(url);
  }
};
